import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ThemeCards from "./ThemeCards";
import { COVERPAGETEMPLATES } from "../../../constants";

const { THEME_THUMBNAILS } = COVERPAGETEMPLATES;

const CoverpageThemes = props => (
  <div className="coverpage-theme-conatiner  animated fadeinright">
    <div className="notes-header">
      <div
        className="right-pane-title back"
        role="button"
        tabIndex={0}
        onClick={props.closeCoverpageThemePane}
        onKeyPress={() => {}}>
        <div>Cover themes</div>
        <div>
          <i>
            <FontAwesomeIcon icon={["far", "times-circle"]} />
          </i>
        </div>
      </div>
    </div>
    <div className="notes-container">
      <div className="content-scroll">
        <span className="addproduct-info margin-bottom">
          Select a theme to define the layout of your cover page{" "}
        </span>
        <div className="coverpage-theme-list">
          {THEME_THUMBNAILS.map(theme => (
            <ThemeCards
              sectionData={props.sectionData}
              theme={theme}
              changeCoverpageTheme={props.changeCoverpageTheme}
              appliedTheme={props.appliedTheme}
            />
          ))}
        </div>
      </div>
    </div>
  </div>
);

export default CoverpageThemes;



// WEBPACK FOOTER //
// ./src/components/DocumentComponents/CoverpageThemes/index.js